module.exports = __webpack_public_path__ + "static/media/construcao_civil.75522c43.jpg";